import { CALL_API } from 'redux-api-middleware'
import { get, post, put } from 'utils/network'
import isInt from 'validator/lib/isInt'

export const searchStudent = (q) => {
  const query = {
    q,
    by: isInt(q) ? 'id' : 'last_name',
  }
  const request = get('/students/search', query)
  request.types = ['STUD_Q_REQ', 'STUD_Q_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}

export const fetchStudent = (id) => {
  return (dispatch, getState) => {
    if (getState().student.getIn(['item', 'id']) === id) {
      // do not fetch if already fetched
      return Promise.resolve()
    }
    let request = get('/students/' + id)
    request.types = ['STUD_REQ', 'STUD_GET_SUCC', 'NOTIF_FAIL']
    return dispatch({ [CALL_API]: request })
  }
}


export const saveStudent = (payload) => {
  let request = null
  if (payload.get('id')) {
    // update
    request = put('/students/' + payload.get('id'), payload)
  } else {
    // create
    request = post('/students', payload)
  }

  request.types = ['STUD_REQ', 'STUD_SAVE_SUCC', 'NOTIF_FAIL']

  return { [CALL_API]: request }
}

export const resetPassword = payload => {
  let request = put('/students/' + payload + '/reset-pass', payload)
  request.types = ['STUD_REQ', 'STUD_SAVE_SUCC', 'NOTIF_FAIL']
  return { [CALL_API]: request }
}


// WEBPACK FOOTER //
// ./src/containers/Students/actions.js